import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('commissions.routes.index'),
        name: 'commission.index',
        component: () =>
            import(
                /* webpackChunkName: "commissions" */ '@/views/commissions/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('commissions.breadcrumbs.index'),
                    to: { name: 'commission.index' },
                    disable: true,
                },
            ],
            showName: i18n.t('commissions.breadcrumbs.index'),
        },
    },
    {
        //path: '/commissions/show/:id',
        path: '/' + i18n.t('commissions.routes.show') + '/:id',
        name: 'commission.show',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "commissions" */ '@/views/commissions/Show.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('commissions.breadcrumbs.index'),
                    to: { name: 'commission.index' },
                    disable: false,
                },
                {
                    text: i18n.t('commissions.breadcrumbs.show'),
                    to: { name: 'commission.show' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
